export const PATH_PARAMETERS_FIRMWARES = "/parameters/firmwares";
export const PATH_PARAMETERS_FIRMWARES_UUID = `${PATH_PARAMETERS_FIRMWARES}/:uuid`;
